// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "pre{font-size:.7rem}.browserIE h2{display:none}.objects-last-seen{padding:0;display:grid;grid-gap:20px;margin:0 auto 20px;grid-template-columns:repeat(auto-fit,minmax(8em,.5fr))}.objects-last-seen.center{justify-content:center}.browserIE .objects-last-seen{display:none}@media (min-width:768px){.objects-last-seen{grid-template-columns:repeat(auto-fit,minmax(8em,.25fr))}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
